"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessibilityContext = void 0;
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const react_router_dom_1 = require("react-router-dom");
const indexDb_1 = require("../../../shared/helpers/indexDb");
const hooks_1 = require("../../../shared/hooks");
const AccessibilityService_1 = require("../services/AccessibilityService");
const AccessibilityContext = (0, react_1.createContext)(undefined);
const AccessibilityContextProvider = ({ children, }) => {
    const searchInputRef = (0, react_1.useRef)(null);
    const faqElementRef = (0, react_1.useRef)(null);
    const [hasFaqs, setHasFaqs] = (0, react_1.useState)(false);
    const [hasSearch, setHasSearch] = (0, react_1.useState)(false);
    const [reqCancelTokenSrc, setReqCancelTokenSrc] = (0, react_1.useState)(null);
    const [loadingScreen, setLoadingScreen] = (0, react_1.useState)(false);
    const [searchData, setSearchData] = (0, react_1.useState)(null);
    const [filters, setFilters] = (0, react_1.useState)({
        typeOfWork: [],
        libraries: [],
    });
    const [totalResults, setTotalResults] = (0, react_1.useState)(0);
    const paginationConfig = {
        itemsPerPage: 10,
    };
    const [searchText, setSearchText] = (0, react_1.useState)(null);
    const { getSearchParam } = (0, hooks_1.useSearchParams)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const [accessibleTitleSearch, setAccessibleTitleSearch] = (0, react_1.useState)('N');
    (0, react_1.useEffect)(() => {
        if (searchText === null &&
            !/^\/pesquisa_acessibilidade\/detalhes/.test(pathname)) {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                const search = getSearchParam('search');
                if (search) {
                    setSearchText(search);
                    yield processSearchData(search);
                }
            }))();
        }
    }, [searchData, searchText, accessibleTitleSearch]);
    const processSearchData = (search_1, page_1, setLoadings_1, ...args_1) => __awaiter(void 0, [search_1, page_1, setLoadings_1, ...args_1], void 0, function* (search, page, setLoadings, _accessibleTitleSearch = 'N') {
        if (_accessibleTitleSearch === 'N' && search === null) {
            return false;
        }
        if (setLoadings === undefined)
            setLoadings = true;
        if (setLoadings)
            setLoadingScreen(true);
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        setReqCancelTokenSrc(cancelTokenSrc);
        const { token } = cancelTokenSrc;
        let data = yield (0, AccessibilityService_1.loadSearchData)(search, _accessibleTitleSearch, token);
        if (data !== false) {
            const filterData = yield (0, AccessibilityService_1.getFiltersData)(data);
            setFilters(filterData);
            if (searchData !== null) {
                if (selectedFilterLibraries) {
                    data = data.filter(item => item.dados_adicionais.B.length > 0 &&
                        item.dados_adicionais.B.some(x => x.code === selectedFilterLibraries));
                }
                if (selectedFilterTypeOfWork) {
                    data = data.filter(item => item.cod_tipo_obra === selectedFilterTypeOfWork);
                }
                if (selectedFilterTitleType === 'TA') {
                    data = data.filter(item => (item === null || item === void 0 ? void 0 : item.possui_acessibilidade) === 'S');
                }
            }
            setTotalResults(data.length);
            page = page === undefined ? 1 : page;
            const maxPage = Math.ceil(data.length / paginationConfig.itemsPerPage);
            if (page > maxPage) {
                page = maxPage;
            }
            data.sort((a, b) => b.descricao.localeCompare(a.descricao));
            const paginatedData = (0, AccessibilityService_1.paginate)(data, paginationConfig.itemsPerPage, page !== null && page !== void 0 ? page : 1);
            setSearchData(paginatedData);
            if (setLoadings)
                setLoadingScreen(false);
            // Scroll automático para os resultados da pesquisa de acessibilidade
            setTimeout(() => {
                const consultaContent = document.querySelector('.consultaContent');
                if (consultaContent) {
                    consultaContent.scrollIntoView({
                        block: 'start',
                        inline: 'nearest',
                        behavior: 'smooth',
                    });
                }
            }, 300);
            return true;
        }
        if (setLoadings)
            setLoadingScreen(false);
        return false;
    });
    const [selectedFilterTypeOfWork, setSelectedFilterTypeOfWork] = (0, react_1.useState)(null);
    const [selectedFilterLibraries, setSelectedFilterLibraries] = (0, react_1.useState)(null);
    const [page, setPage] = (0, react_1.useState)(1);
    const [selectedFilterTitleType, setSelectedFilterTitleType] = (0, react_1.useState)('TT');
    const cancelRequest = () => {
        if (reqCancelTokenSrc !== null) {
            reqCancelTokenSrc.cancel('Request canceled by the user');
        }
    };
    const clearFlowStates = () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise(resolve => {
            setSearchText(null);
            setFilters({ libraries: [], typeOfWork: [] });
            setSearchData(null);
            setTotalResults(0);
            setSelectedFilterLibraries(null);
            setSelectedFilterTypeOfWork(null);
            setSelectedFilterTitleType('TT');
            setTimeout(() => resolve(), 500);
        });
    });
    const memoizedData = (0, react_1.useMemo)(() => ({
        faqElementRef,
        searchInputRef,
        hasFaqs,
        setHasFaqs,
        hasSearch,
        setHasSearch,
        reqCancelTokenSrc,
        setReqCancelTokenSrc,
        cancelRequest,
        loadingScreen,
        setLoadingScreen,
        indexDbConsulta: indexDb_1.indexDbConsulta,
        searchData,
        setSearchData,
        filters,
        setFilters,
        selectedFilterTypeOfWork,
        setSelectedFilterTypeOfWork,
        selectedFilterLibraries,
        setSelectedFilterLibraries,
        searchText,
        setSearchText,
        paginationConfig,
        processSearchData,
        totalResults,
        setTotalResults,
        clearFlowStates,
        page,
        setPage,
        selectedFilterTitleType,
        setSelectedFilterTitleType,
        accessibleTitleSearch,
        setAccessibleTitleSearch,
    }), [
        faqElementRef,
        hasFaqs,
        hasSearch,
        searchInputRef,
        reqCancelTokenSrc,
        loadingScreen,
        searchData,
        filters,
        selectedFilterTypeOfWork,
        selectedFilterLibraries,
        searchText,
        totalResults,
        selectedFilterTitleType,
        accessibleTitleSearch,
    ]);
    return (react_1.default.createElement(AccessibilityContext.Provider, { value: memoizedData }, children));
};
const useAccessibilityContext = () => {
    const context = (0, react_1.useContext)(AccessibilityContext);
    if (context === undefined)
        throw new Error('useAccessibilityContext must be used within a AccessibilityContextProvider');
    return context;
};
exports.useAccessibilityContext = useAccessibilityContext;
exports.default = AccessibilityContextProvider;
